import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { IInventoryPurchaseOrderFormFields } from "..";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";

interface IAdditionalNotesFormFieldsProps {
  formHook: UseFormReturn<IInventoryPurchaseOrderFormFields, any>;
}

const AdditionalNotesFormFields: React.FC<IAdditionalNotesFormFieldsProps> = ({ formHook }) => {
  const { getRouteKey } = useRouter();
  const [editPermission, setEditPermission] = useState<boolean>(false);
  const canCreatePO = useFeatureAccess("PO_CREATE_ACTION");
  const userPermissions = useAppSelector((state) => state.auth?.userPermissions);
  const { purchaseOrderDetails: PODetails } = useRouteInfo(getRouteKey("INVENTORY", "id"))?.routeState
    ?.state as IInventoryState;

  useEffect(() => {
    if (!userPermissions || !PODetails) return;
    if (PODetails?.po_status !== "awaiting_grn" && canCreatePO) {
      setEditPermission(true);
    } else {
      setEditPermission(false);
    }
  }, [PODetails, userPermissions, canCreatePO]);

  return (
    <div>
      <div>
        <h2 className="font-semibold text-sm text-[#1F1F23]">Additional Notes</h2>
        {editPermission && (PODetails?.po_status === "pre_draft" || PODetails?.po_status === "draft") ? (
          <textarea
            id="additional-note"
            rows={4}
            {...formHook.register("additional_note")}
            className="block bg-white mt-3 p-2.5 border border-gray-300 focus:border-blue-500 rounded-lg w-full text-gray-900 text-xs 2xl:text-sm focus:ring-blue-500"
            placeholder="Max character limit is 2000"
          ></textarea>
        ) : (
          <p className="mt-2 whitespace-pre-line text-[10px] sm:text-xs 2xl:text-sm">{PODetails?.additional_note}</p>
        )}
      </div>
      <div>
        <h2 className="mt-8 font-semibold text-sm text-[#1F1F23]">Terms &amp; Conditions</h2>
        {editPermission && (PODetails?.po_status === "pre_draft" || PODetails?.po_status === "draft") ? (
          <textarea
            id="terms-conditions"
            rows={6}
            {...formHook.register("terms_conditions", { required: false })}
            className="block bg-white mt-3 p-2.5 border border-gray-300 focus:border-blue-500 rounded-lg w-full text-gray-900 text-xs 2xl:text-sm focus:ring-blue-500"
            placeholder="Max character limit is 5000"
          ></textarea>
        ) : (
          <p className="mt-2 whitespace-pre-line text-[10px] sm:text-xs 2xl:text-sm">{PODetails?.terms_conditions}</p>
        )}
      </div>
    </div>
  );
};
export default AdditionalNotesFormFields;
